import { faSync, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment-timezone';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';

import { Config } from '../../../../../shared/config';
import etlService from '../../../ETL/etlService';

import EtlJobView from '../EtlJobView';
import './etlJobViewStyle.scss';

class EtlJobList extends Component {
    constructor(props) {
        super(props);
        const startDate = moment(new Date()).subtract(7, 'days').toDate();
        this.state = {
            etlJobData: [],
            interval: {
                startDate: startDate,
                endDate: new Date(),
            },
            autoRefreshSecs: 0,
            noRecordsMessage: null,
            showPagination: false,
            selectedRowIndex: null,
            lastRefreshTime: null,
            selectedDataSourceId: null,
            refreshTriggerTimestamp: 0,
            refreshIntervalId: null,
        };
        this.etlService = new etlService();

        this.getEtlTableTrProps = this.getEtlTableTrProps.bind(this);

        this.handleIntervalChange = this.handleIntervalChange.bind(this);
        this.onRefreshClick = this.onRefreshClick.bind(this);
        this.setAutoRefresh = this.setAutoRefresh.bind(this);
    }

    /**
     * Ui elements rendering
     */
    render() {
        const {
            etlJobData,
            noRecordsMessage,
            showPagination,
            autoRefreshSecs,
            lastRefreshTime,
            selectedDataSourceId,
            interval,
        } = this.state;
        const refreshIconClass = autoRefreshSecs > 0 ? 'spinning' : '';
        const startTimeText = moment(interval.startDate).format(Config.UI_TIMESTAMP_FORMAT);
        const endTimeText = moment(interval.endDate).format(Config.UI_TIMESTAMP_FORMAT);
        const intervalText = `${startTimeText} - ${endTimeText}`;
        const dateRangeSettings = {
            startDate: interval.startDate,
            endDate: interval.endDate,
            timePicker: true,
            locale: { format: Config.UI_TIMESTAMP_FORMAT },
        };

        return (
            <>
                <Row className="mt-4 align-items-center">
                    <Col sm={2} md={5}>
                        <h5 className="mb-0 mt-3 ml-2">File Processing Status:</h5>
                    </Col>
                    <Col sm={10} md={7} className="d-flex flex-row justify-content-end">
                        <Form.Group as={Row} className="float-right col-12 mb-0 align-items-center">
                            <span className="mr-2 refresh-time">Last Refreshed Time: {lastRefreshTime}</span>
                            <DateRangePicker initialSettings={dateRangeSettings} onCallback={this.handleIntervalChange}>
                                <Form.Control
                                    as="input"
                                    type="text"
                                    sm="5"
                                    size="sm"
                                    className="col-5 text-center"
                                    value={intervalText || ''}
                                    readOnly
                                    title="Time interval"
                                />
                            </DateRangePicker>
                            <Col className="d-flex flex-row">
                                <Dropdown as={ButtonGroup} className="mr-sm-2" size="sm">
                                    <Dropdown.Toggle variant="outline-secondary" className="mr-1" size="sm">
                                        Auto Refresh{' '}
                                        {autoRefreshSecs ? 'every ' + autoRefreshSecs + ' seconds' : 'Disabled'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(0)}>None</Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(5)}>5 Seconds</Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(10)}>
                                            10 Seconds
                                        </Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(30)}>
                                            30 Seconds
                                        </Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(60)}>1 Minute</Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(120)}>
                                            2 Minutes
                                        </Dropdown.Item>
                                        <Dropdown.Item onSelect={() => this.setAutoRefresh(300)}>
                                            5 Minutes
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Button
                                    variant="outline-secondary"
                                    sm="1"
                                    size="sm"
                                    onClick={this.onRefreshClick}
                                    title="Refresh Jobs"
                                >
                                    <FontAwesomeIcon icon={faSync} className={refreshIconClass} />
                                </Button>
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
                <div className="table-responsive-cm">
                    <ReactTable
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            row[filter.id] !== undefined
                                ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                : false
                        }
                        columns={[
                            {
                                Header: 'Customer Name',
                                accessor: 'customerName',
                                width: 200,
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Job ID',
                                accessor: 'dataSourceId',
                                width: 100,
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Data Type',
                                id: 'dataType',
                                accessor: (data) => {
                                    const { dataSource } = data;
                                    // The third value is the dataType
                                    const [, , dataType] = dataSource.split('/');
                                    return dataType.replace('_', ' ');
                                },
                                width: 150,
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'File Name',
                                accessor: 'fileName',
                                width: 200,
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Started On',
                                accessor: 'transientIngestDate',
                                Cell: (props) => {
                                    const startedOn = props.value
                                        ? moment.utc(props.value, Config.API_TIMESTAMP_FORMAT).local()
                                        : '';
                                    return props.value
                                        ? moment(startedOn, Config.API_TIMESTAMP_FORMAT).format(
                                              Config.UI_TIMESTAMP_FORMAT,
                                          )
                                        : '';
                                },
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'Last Updated On',
                                id: 'lastUpdatedOn',
                                accessor: (data) => {
                                    const processTimeStamp = data.processTimeStamp;
                                    const conformedProcessTimeStamp = data.conformedProcessTimeStamp;
                                    const conformedStatus = data.conformedStatus;

                                    // Use conformedProcessTimeStamp if conformed is processing
                                    if (conformedStatus) {
                                        return conformedProcessTimeStamp;
                                    }
                                    return processTimeStamp;
                                },
                                Cell: (props) => {
                                    const timestamp = props.value
                                        ? moment.utc(props.value, Config.UI_TIMESTAMP_FORMAT).local()
                                        : '';
                                    return props.value
                                        ? moment(timestamp, Config.API_TIMESTAMP_FORMAT).format(
                                              Config.UI_TIMESTAMP_FORMAT,
                                          )
                                        : '';
                                },
                                sortMethod: (a, b) => {
                                    var a1 = new Date(a).getTime();
                                    var b1 = new Date(b).getTime();
                                    if (a1 > b1) return 1;
                                    else if (a1 < b1) return -1;
                                    else return 0;
                                },
                                width: 200,
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: 'File Import Status',
                                accessor: 'transientStatus',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <span title="Imported Valid Rows Count">Imported Rows Valid</span>,
                                accessor: 'transientValidCount',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <span title="Imported Invalid Rows Count">Imported Rows Invalid</span>,
                                accessor: 'transientInvalidCount',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <span title="Reportable Record Status">Reportable Record Status</span>,
                                accessor: 'conformedStatus',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <span title="Reportable Valid Rows Count">Reportable Rows Valid</span>,
                                accessor: 'conformedValidCount',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => (
                                    <span title="Reportable Invalid Rows Count">Reportable Rows Invalid</span>
                                ),
                                accessor: 'conformedInvalidCount',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                            {
                                Header: () => <span title="Error Notes">Notes</span>,
                                accessor: 'notes',
                                Filter: ({filter, onChange}) => filterRender(filter, onChange),
                            },
                        ]}
                        data={etlJobData}
                        noDataText={noRecordsMessage}
                        minRows={etlJobData.length}
                        showPagination={showPagination}
                        pageSize={etlJobData.length}
                        className="-highlight cursor-pointer w-100"
                        style={
                            etlJobData.length >= 10
                                ? {
                                      height: 'calc(100vh - 400px)',
                                  }
                                : {}
                        }
                        defaultSorted={[{ id: 'lastUpdatedOn', desc: true }]}
                        getTrProps={this.getEtlTableTrProps}
                    />
                </div>

                <EtlJobView dataSourceId={selectedDataSourceId} customerId={this.props.customerId} mode={this.props.mode} />
            </>
        );
    }

    /**
     * On row click
     */
    getEtlTableTrProps = (state, rowInfo) => {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: () => {
                    this.setState({
                        selectedRowIndex: rowInfo.index,
                        selectedDataSourceId: rowInfo.original.dataSourceId,
                    });
                },
                style: {
                    background: rowInfo.index === this.state.selectedRowIndex ? '#166c9d29' : 'white',
                    color: rowInfo.index === this.state.selectedRowIndex ? 'blue' : '#4b4b4b',
                },
            };
        } else {
            return {};
        }
    };

    /**
     * Component mount method
     */
    componentDidMount() {
        const { interval } = this.state;
        this.refreshJobList(interval);
    }

    componentDidUpdate(prevProps, prevState) {
        let newTriggerTimestamp = 0;
        if (this.props.customerId !== prevProps.customerId) {
            const { interval } = this.state;
            this.refreshJobList(interval);
        }
        if (this.props.refreshJobListTrigger) {
            newTriggerTimestamp = this.props.refreshJobListTrigger.refreshJobListPayload;
        }
        if (newTriggerTimestamp > prevState.refreshTriggerTimestamp && prevState.autoRefreshSecs === 0) {
            this.setState(
                {
                    refreshTriggerTimestamp: newTriggerTimestamp,
                    autoRefreshSecs: 5,
                },
                () => this.autoRefresh(),
            );
        }
    }

    handleIntervalChange(start, end) {
        this.setState({
            interval: {
                startDate: start,
                endDate: end,
            },
        });
    }

    onRefreshClick() {
        const { interval } = this.state;
        this.refreshJobList({
            startDate: interval.startDate,
            endDate: null,
        });
    }

    setAutoRefresh(secs) {
        this.setState({ autoRefreshSecs: secs }, () => this.autoRefresh());
    }

    autoRefresh() {
        const { autoRefreshSecs, refreshIntervalId } = this.state;
        if (refreshIntervalId) {
            // First Clear the interval if currently set
            clearInterval(refreshIntervalId);
        }
        if (autoRefreshSecs > 0) {
            // Create new interval
            const newRefreshIntervalId = setInterval(() => this.autoRefreshCallback(), autoRefreshSecs * 1000);
            this.setState({
                refreshIntervalId: newRefreshIntervalId,
            });
        }
    }

    autoRefreshCallback = () => {
        const { interval } = this.state;
        this.refreshJobList({
            startDate: interval.startDate,
            endDate: null,
        });
    };

    refreshJobList(interval) {
        const data = {
            interval: interval,
            customerId: this.props.customerId,
            mode: this.props.mode,
        };
        this.etlService.getEtlJobList(data).then((res) => {
            if (res && res.status === 'Success' && res.data && res.data.length > 0) {
                this.setState({
                    etlJobData: res.data,
                    noRecordsMessage: null,
                    lastRefreshTime: moment().format(Config.UI_TIMESTAMP_FORMAT),
                });
            } else {
                this.setState({
                    etlJobData: [],
                    noRecordsMessage: 'No Jobs Found',
                });
            }
        });
    }
}

const filterRender = (filter, onChange) => {
    return (
        <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
        <FontAwesomeIcon icon={faSearch} className='filter-search-icon' />
        <input
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
        style={{
            width: '100%',
            border: '0px'
        }}
        autoComplete='none'
        />
    </div>
    )
}

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        refreshJobListTrigger: state.refreshJobListAction,
    };
};

EtlJobList.propTypes = {
    history: PropTypes.object.isRequired,
    customerId: PropTypes.number,
    mode: PropTypes.string,
    refreshJobListTrigger: PropTypes.shape({
        refreshJobListPayload: PropTypes.shape({
            payload: PropTypes.string,
        }),
    }),
};

export default connect(MapStateToProps)(withRouter(EtlJobList));
